import { differenceInMilliseconds, formatDistanceToNow } from 'date-fns'
import { useEffect, useState } from 'react'

export function Time(props: { value: Date | null; suffix: boolean }) {
  const [lastFetched, setLastFetched] = useState('')
  useEffect(() => {
    let interval: number
    const callout = () => {
      const nextInterval = props.value
        ? differenceInMilliseconds(new Date(), props.value)
        : 5000
      setLastFetched(
        props.value
          ? formatDistanceToNow(props.value, {
              includeSeconds: true,
              addSuffix: props.suffix,
            })
          : '',
      )
      interval = window.setTimeout(
        () => callout(),
        nextInterval < 5000 ? 5000 : nextInterval,
      )
    }
    callout()
    return () => {
      clearTimeout(interval)
    }
  }, [props.value, props.suffix])

  return <>{lastFetched || 'less than 5 seconds ago'}</>
}
